"use strict";
(() => {
  // frontend/modules/customers-identity.js
  (function main() {
    const searchParams = new URLSearchParams(window.location.search);
    const code = searchParams.get("code");
    if (code) {
      localStorage.setItem("code", code);
      window.location.replace(`/customer_identity/sso_hint?accountnumber=0&provider=customer_identity&return_to=%2Fpages%2Faccount%3Fpb%3D0`);
      return;
    }

    function preserveWholesaleAccount() {
      if (window.location.pathname !== "/pages/account" || searchParams.get("pb") !== "0") return;
      const bridgeAttempted = searchParams.get("b2b_bridge") === "1";
      if (document.body?.classList.contains("customer-b2b")) {
        if (bridgeAttempted) {
          const cleanUrl = new URL(window.location);
          cleanUrl.searchParams.delete("b2b_bridge");
          window.history.replaceState({}, "", cleanUrl.toString());
        }
        return;
      }
      if (bridgeAttempted) return;
      const returnUrl = new URL("/pages/account", window.location.origin);
      returnUrl.searchParams.set("pb", "0");
      returnUrl.searchParams.set("b2b_bridge", "1");
      const bridgeUrl = new URL("/customer_identity/sso_hint", window.location.origin);
      bridgeUrl.searchParams.set("accountnumber", "0");
      bridgeUrl.searchParams.set("provider", "customer_identity");
      bridgeUrl.searchParams.set("return_to", `${returnUrl.pathname}${returnUrl.search}`);
      window.location.replace(bridgeUrl.toString());
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", preserveWholesaleAccount, { once: true });
    } else {
      preserveWholesaleAccount();
    }
  })();
})();
